// extracted by mini-css-extract-plugin
export var defaultWrapper = "_h0-3";
export var downloadButton = "_h0-4";
export var fileContainer = "_h0-9 _h0-7";
export var fileContainerBase = "_h0-7";
export var fileContainerBaseSm = "_h0-a _h0-7";
export var fileContainerFixedHeight = "_h0-8 _h0-7";
export var fileContainerFixedHeightSm = "_h0-c _h0-a _h0-7";
export var fileContainerSm = "_h0-b _h0-a _h0-7";
export var fileInfo = "_h0-5";
export var fileInfoWidthRestricted = "_h0-6";
export var fileType = "_h0-1";
export var fileTypeName = "_h0-2";
export var fileTypeSm = "_h0-d _h0-1";
export var image = "_h0-0";
export var link = "_h0-f";
export var overflowEllipsis = "_h0-e";